import { brand } from '@helpers/brand';
import { Layers } from '@helpers/layers';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.section `
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: ${Layers.Modal};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${rgba(brand.actualBlack, 0.72)};
  backdrop-filter: blur(8px);
`;
const PopupWrapperStyles = {
    Container,
};
export default PopupWrapperStyles;
